/**
 * Which file the player loads for a playback speed.
 *
 * The server pre-renders a sentence's reference recording and a lesson's
 * video at 0.5/0.75/1.25/1.5 (`referenceAudioVariants` / `videoVariants`,
 * Rubber Band with the pitch kept) because the browser's own `playbackRate`
 * stretch is what made slow speeds sound stretched and ringing (owner,
 * 2026-09-24). When the speed the learner picked has a rendered file, that
 * file plays at 1x; otherwise — 1x itself, or a lesson the server has not
 * rendered yet — the 1x file plays with `playbackRate = speed`, exactly as
 * before. Same rule as the Android app's `Sentence.referenceAudioFor`.
 */
export function mediaSourceFor(baseUrl, variants, speed) {
  const rate = Number(speed) || 1
  const variant =
    rate !== 1 && Array.isArray(variants)
      ? variants.find((v) => v && typeof v.url === 'string' && v.url && Math.abs(Number(v.speed) - rate) < 1e-6)
      : null
  if (variant) return { src: variant.url, playbackRate: 1, rendered: true }
  return { src: baseUrl ?? '', playbackRate: rate, rendered: false }
}
